import { type ColorAndTrimSettingsSpecsFragment } from '../../../../api/fragments/ColorAndTrimSettingsSpecs';
import { type ColorBlockSpecsFragment } from '../../../../api/fragments/ColorBlockSpecs';
import { type MatrixSpecsFragment } from '../../../../api/fragments/MatrixSpecs';
import { type TranslatedStringDataFragment } from '../../../../api/fragments/TranslatedStringData';
import {
    type ColorAndTrimSettingsInput,
    type BlockInput,
    type TrimBlockInput as ApiTrimBlockInput,
    BlockType,
} from '../../../../api/types';

export const FORM_NAME = 'variantConfiguratorTrimBlocks';

export type TrimSettingFormValues = ColorAndTrimSettingsInput & {
    image?: File | ColorAndTrimSettingsSpecsFragment['image'];
    sectionImages?: {
        colorId: string;
        colorName: TranslatedStringDataFragment;
        variantTrimImage?: File | MatrixSpecsFragment['variantTrimImage'];
    }[];
};
export type TrimBlockInput = Omit<ApiTrimBlockInput, 'trimSettings'> & {
    id?: string;
    trimSettings: TrimSettingFormValues[];
};
export type TrimBlockFormValues = Omit<BlockInput, 'trimBlockInput'> & {
    trimBlockInput: TrimBlockInput;
};

export const getDefaultTrimSetting = (colorBlock?: ColorBlockSpecsFragment) => ({
    name: {
        defaultValue: '',
        overrides: [],
    },
    code: '',
    hex: '',
    price: 0,
    sectionImages: colorBlock?.colorSettings.map(color => ({
        colorId: color.id,
        colorName: color.name,
        variantTrimImage: undefined,
    })),
});

export const getDefaultTrimBlockInput = (colorBlock?: ColorBlockSpecsFragment): TrimBlockInput => ({
    isActive: true,
    trimSettings: [getDefaultTrimSetting(colorBlock)],
    sectionTitle: {
        defaultValue: '',
        overrides: [],
    },
});

export const getDefaultTrimBlock = (colorBlock?: ColorBlockSpecsFragment): TrimBlockFormValues => ({
    type: BlockType.Trim,
    trimBlockInput: getDefaultTrimBlockInput(colorBlock),
});
